"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ucfirst = require("@seafront/ucfirst");

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _DefaultScreen = _interopRequireDefault(require("../02_molecules/DefaultScreen"));

var _TicketWidget = _interopRequireDefault(require("../02_molecules/TicketWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileTicketPage = function MobileTicketPage(_ref) {
  var ticket = _ref.ticket,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack;
  var ticketDetails = ticket.ticketDetails;
  var dt = (0, _ucfirst.ucfirstEachWord)(ticketDetails.originTerminal.name);
  var at = (0, _ucfirst.ucfirstEachWord)(ticketDetails.destinationTerminal.name);

  var title = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }, dt, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "arrow right",
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }), at);

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: title,
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_TicketWidget["default"], {
    ticket: ticket,
    translationManager: translationManager,
    translatorForNamespace: translatorForNamespace
  }));
};

var _default = MobileTicketPage;
exports["default"] = _default;